<template>
  <div class="orderBox">
    <div class="form-title">受保人</div>
    <FormItem :prop="formKey + '.relation'" label="与投保人关系" :rules="$units.formRule.required('请选择')">
      <lzDicTxt v-if="disabled" dicType="RELATION" :dicCode="formData.relation"></lzDicTxt>
      <Select v-else v-model="formData.relation" filterable transfer clearable>
        <Option v-for="(txt, value) in RELATION" :value="value" :key="value">{{ txt }}</Option>
      </Select>
    </FormItem>
    <template v-if="formData.relation != 1">
      <person :formData="formData" :formKey="formKey" :disabled="disabled"></person>
      <detail :formData="formData" :formKey="formKey" :disabled="disabled"></detail>
    </template>
  </div>
</template>

<script>
import person from "./person";
import detail from "./detail";
import lzDicTxt from '@/components/commons/lzDicTxt';
export default {
  components: { person, detail, lzDicTxt },
  props: {
    disabled: {},
    formData: {
      default() {
        return {};
      }
    },
    formKey: {}
  },
  data() {
    return {
      RELATION: JSON.parse(localStorage.dic)['RELATION'], // 关系
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() { },
  methods: {
  }
};
</script>
<style lang="scss" scoped></style>
